import { Route } from "react-router";
import {
  AgentAccessDeniedPage,
  AgentClientsPage,
  AgentDashboardPage,
  AgentEsouqOrdersPage,
  AgentKycPage,
  AgentLiveTransactionsPage,
  AgentTransactionStatsPage,
  AgentWithdrawalsPage,
  AnimatedRoute,
  ChatPage,
} from "../import";

const AgentRoutes = () => (
  <>
    <Route
      path="dashboard"
      element={
        <AnimatedRoute>
          <AgentDashboardPage />
        </AnimatedRoute>
      }
    />
    <Route
      path="live-transactions"
      element={
        <AnimatedRoute>
          <AgentLiveTransactionsPage />
        </AnimatedRoute>
      }
    />
    <Route
      path="transaction-stats"
      element={
        <AnimatedRoute>
          <AgentTransactionStatsPage />
        </AnimatedRoute>
      }
    />
    <Route
      path="clients"
      element={
        <AnimatedRoute>
          <AgentClientsPage />
        </AnimatedRoute>
      }
    />
    <Route
      path="withdrawals"
      element={
        <AnimatedRoute>
          <AgentWithdrawalsPage />
        </AnimatedRoute>
      }
    />
    <Route
      path="esouq-orders"
      element={
        <AnimatedRoute>
          <AgentEsouqOrdersPage />
        </AnimatedRoute>
      }
    />
    <Route
      path="kyc"
      element={
        <AnimatedRoute>
          <AgentKycPage />
        </AnimatedRoute>
      }
    />
    <Route
      path="chat"
      element={
        <AnimatedRoute>
          <ChatPage />
        </AnimatedRoute>
      }
    />
    <Route path="access-denied" element={<AgentAccessDeniedPage />} />
  </>
);

export default AgentRoutes;
